<style lang="scss">
@import 'resources/sass/v1/abstracts/_variables';

.newsletter-form {
    .error {
        @media screen and (min-width: $screen-lg) {
            position: absolute;
            left: 0;
            top: calc(100% + 8px);
        }
    }
}
</style>

<template>
    <div id="newsletter-form" class="form newsletter-form flex-1" :class="{ processing: processing }">
        <ValidationObserver v-slot="obs" ref="observer" tag="form" @submit.prevent="submit()">
            <div class="flex flex-col md:flex-row md:items-center space-y-5 md:space-y-0 items-start md:space-x-10 relative">
                <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props" :name="translations.label" :slim="true">
                    <div class="lg:flex-1" :class="props.classes">
                        <input type="text" id="newsletter_email" class="py-[.5625rem] w-full md:w-auto lg:w-full px-[1.8125rem] text-18 rounded-full border border-gray" :placeholder="translations.label" v-model="formData.email" />
                        <span class="error text-red text-12">{{ props.errors[0] || compiledErrors[0] }}</span>
                    </div>
                </ValidationProvider>
                <button class="btn btn-green">
                    {{ translations.button }}
                </button>
            </div>
        </ValidationObserver>

        <div class="spinner-background">
            <div class="spinner"></div>
        </div>
    </div>
</template>

<script>
import hasErrors from '@mixins/hasErrors';

export default {
    mixins: [hasErrors],

    props: {
        translations: {
            type: Object,
            required: true,
        },

        googleAnalyticsEventLabel: {
            type: String,
            required: false,
        },

        sharpspringEndpoint: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            processing: false, //when posting the formData
            submitted: false, //when formData is successfully submitted

            formData: {
                email: '',
                sharpspringEndpoint: '',
                googleAnalyticsEventLabel: '',
            },
        };
    },

    mounted() {
        this.formData.sharpspringEndpoint = this.sharpspringEndpoint;
        this.formData.googleAnalyticsEventLabel = this.googleAnalyticsEventLabel;
    },

    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if (isValid) {
                this.processing = true;
                axios
                    .post(route('newsletters.create'), this.formData)
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) this.done = true;

                        document.getElementById('newsletter-form').replaceWith(this.translations.success_message);

                        this.formData.email = '';
                        this.sendGaEvent();
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
        },
    },
};
</script>
